
import { useState, useRef, useMemo, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { doc, getDoc, addDoc, setDoc, Timestamp } from "firebase/firestore";
import { db } from '../../config/firebase';
import dayjs from 'dayjs';
import ReactGA from "react-ga4";

import { VscMail } from "react-icons/vsc";
import { PiPhoneLight } from "react-icons/pi";
import { RiLockPasswordLine } from "react-icons/ri";
import { VscWholeWord } from "react-icons/vsc";

import Spinner from '../../components/Loading/TailSpin';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import Footer from '../../components/footer/Footer';
import saycryptLogo from "../../assets/img/Saycrypt_Logo.png"
import { TncContent } from './TncContent';

function RequestAccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const tncWrapperRef = useRef(null);

  const [userId, setUid] = useState("");
  const [password, setPassword] = useState("")
  const [cnfPassword, setcnfPassword] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [mobile, setMobile] = useState("")

  const [isReqSubmited, setIsReqSubmited] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showWarning, setShowWarning] = useState(false);

  const [showTnCPopup, setShowTnCPopup] = useState(false);
  useOutsideCloser(tncWrapperRef, setShowTnCPopup)


  let generatedUserId = useMemo(() => {
    let intermCode = "";
    for (let i = 0; i < 6; i++) {
      intermCode += ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)))
    }
    // console.log(intermCode);
    return intermCode
  }, [])

  const sendUserRequest = async () => {
    setIsLoading(true);
    const enteredData = {
      createdAt: Timestamp.now(),
      groups: [],
      name,
      email,
      mobile,
      password,
      requestedAccess: true,
    }

    try {
      const docRef = doc(db, 'users', generatedUserId);

      await setDoc(docRef, enteredData);
      setIsReqSubmited(true);
      sendAnalytics();
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
    setIsLoading(false);
  };

  const sendAnalytics = (status) => {
    ReactGA.event({
      category: "Request Access",
      action: "Requested",
    });
  }

  const handleSubmit = () => {
    if (name.length < 36 && email.length < 36 && name !== "" && String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) && mobile.length === 10)
      sendUserRequest()
    else
      setShowWarning(true);
  }

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Request Access" })
  }, [])

  if (!isLoading)
    return (
      <div className='relative bg-lightPrimary w-full h-full flex flex-col items-center justify-center p-6'>

        <img className='absolute top-[45px] left-0 right-0 mx-auto ' src={saycryptLogo} alt="logo" width={200} />

        {!isReqSubmited ?
          <div className="w-full mt-[70px] md:w-[420px] p-9 bg-lightPrimary flex flex-col items-center rounded-xl ">

            <div className="w-full grid grid-cols-2 gap-4">

              <div className="col-span-2 flex justify-start w-full">
                <div className={`border ${name.length > 36 || (showWarning && name === "") ? "border-red-500" : "border-gray-300"} bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-xl px-2.5 py-2.5 `}>
                  <div className="flex h-full w-full items-center font-normal ">
                    <VscWholeWord
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary " />
                    <input
                      onChange={(e) => {
                        if (e.target.value === "")
                          setShowWarning(true);
                        setName((e.target.value))
                      }}
                      value={name}
                      type="text"
                      placeholder="Full Name"
                      className="block ml-0 px-2 h-auto w-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>
              {/* 36 36 10 */}
              <div className="col-span-2 flex justify-start w-full">
                <div className={`border ${email.length > 36 ||
                  (showWarning && !String(email)
                    .toLowerCase()
                    .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )) ? "border-red-500" : "border-gray-300"} bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-xl px-2.5 py-2.5 `}>
                  <div className="flex h-full w-full items-center font-normal ">
                    <VscMail
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary " />
                    <input
                      onChange={(e) => {
                        const email = e.target.value

                        setEmail(email)
                      }}
                      value={email}
                      type="text"
                      placeholder="Email"
                      className="block ml-0 px-2 h-auto w-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>

              <div className="col-span-2 flex justify-start w-full">
                <div className={`border ${showWarning && mobile.length !== 10 ? "border-red-500" : "border-gray-300"} bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-xl px-2.5 py-2.5 `}>
                  <div className="flex h-full w-full items-center font-normal ">
                    <PiPhoneLight
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary " />
                    <input
                      onChange={(e) => {
                        setMobile(e.target.value.replace(/\D/g, ""))
                      }}
                      value={mobile}
                      type="text"
                      placeholder="Mobile"
                      className="block ml-0 px-2 h-auto w-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>

            </div>

            <button
              onClick={handleSubmit}
              className=" mt-10 flex items-center justify-center py-2.5 w-[100%] bg-white rounded-xl border border-headPrimary
            headPrimary text-2xl font-semibold text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:border-[#40cb7b] hover:font-bold">
              Request to Let Me In
            </button>

          </div>

          :
          <div className="flex flex-col items-center ">
            {/* Request Submitted Successfully */}

            <div className="text-2xl font-medium text-headPrimary text-center">Hey {name},<br />Your Request Submitted Successfully !!!</div>
            <div className="mt-4 text-[#b1b8b5] text-base text-center">Soon and You will Receive the Status of your Request / SignIn Details on Provided Email ({email}) or Mobile ({mobile}).</div>
          </div>
        }
        {showTnCPopup &&
          <div style={{ "backgroundColor": "rgba(0, 0, 0, 0.8)" }}
            className="fixed inset-0 z-50 flex items-center justify-center outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-fit">

              <div ref={tncWrapperRef} className="relative flex w-[90vw] h-[90vh] sm:w-[80vw] sm:h-[85vh] p-6 pt-4 sm:p-10 sm:pt-7 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

                <button
                  onClick={() => {
                    setShowTnCPopup(false)
                  }}
                  type="button"
                  className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="static-modal"
                >
                  <svg
                    className="h-3 w-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>

                <div className="text-2xl font-semibold text-center text-headPrimary"> T&C with Privacy & Data Policy </div>

                <div className='w-full h-[calc(100%-30px)] overflow-y-auto py-5 px-1 flex flex-col text-base text-gray-600' >

                  {TncContent.map((item) => (
                    <div className="flex flex-col pb-5">
                      <div className="font-semibold mb-1">{item.name}</div>
                      <div className="font-normal  text-justify">{item.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        }

        <div className="absolute bottom-5 left-0 right-0 text-center text-3xs font-normal text-gray-300">By Sending Request, I Understand, Accept & Agree all the
          <span onClick={() => { setShowTnCPopup(true) }} className='hover:text-our-600 cursor-pointer'> T&C</span> with Privacy & Data Policy.</div>

        <Footer />
      </div>
    )

  else return (
    <div className='bg-lightPrimary w-full h-full flex items-center justify-center'>
      <Spinner />
    </div>
  )
}

export default RequestAccess